import { env } from './env'

export const TENANT_ID = env('VITE_TENANT_ID')
